import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomIn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 14.5L11.3583 11.3583M7.27778 5V7.275V9.55M5 7.27778H7.275H9.55M13.0556 7.27778C13.0556 10.4688 10.4688 13.0556 7.27778 13.0556C4.0868 13.0556 1.5 10.4688 1.5 7.27778C1.5 4.0868 4.0868 1.5 7.27778 1.5C10.4688 1.5 13.0556 4.0868 13.0556 7.27778Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgZoomIn;
